import {
    fieldsForAssertIds,
    readParamUiValue,
    writeParamValue,
} from "./flowAssertParamFields";

/**
 * Editor de parâmetros de assert.
 * Enums → chips selecionáveis; texto → input.
 */
export default function FlowAssertParamEditor({
    assertIds = [],
    assertParams = {},
    onChange,
}) {
    const fields = fieldsForAssertIds(assertIds);
    if (fields.length === 0) return null;

    return (
        <div
            className="space-y-3 border-t border-gray-700 pt-2"
            aria-label="Parâmetros dos asserts"
        >
            <div>
                <p className="text-[10px] uppercase tracking-wide text-gray-500">
                    Parâmetros
                </p>
                <p className="text-[11px] text-gray-500 leading-snug">
                    Escolha o valor esperado. Campos com opções usam toque único (sem digitar).
                </p>
            </div>

            <div className="flex flex-col gap-3">
                {fields.map((field) => {
                    const uiValue = readParamUiValue(field, assertParams);
                    const missing = field.required && (uiValue === "" || uiValue == null);

                    const setValue = (nextUi) => {
                        const encoded = writeParamValue(field, nextUi);
                        onChange(field.key, encoded === undefined ? "" : encoded);
                    };

                    return (
                        <div
                            key={`${field.assertId}-${field.key}`}
                            className="space-y-1"
                        >
                            <div className="flex items-baseline justify-between gap-2">
                                <p className="text-xs text-gray-200 font-medium">
                                    {field.label}
                                    {field.required ? (
                                        <span className="text-red-400 ml-0.5">*</span>
                                    ) : null}
                                </p>
                                <span className="text-[10px] text-gray-500 truncate">
                                    {field.assertId.replace(/^assert/, "")}
                                </span>
                            </div>
                            {field.help ? (
                                <p className="text-[10px] text-gray-500 leading-snug">
                                    {field.help}
                                </p>
                            ) : null}

                            {field.type === "enum" ? (
                                <div
                                    role="listbox"
                                    aria-label={field.label}
                                    className="flex flex-wrap gap-1.5"
                                >
                                    {(field.options || []).map((opt) => {
                                        const selected = uiValue === opt.value;
                                        return (
                                            <button
                                                key={opt.value}
                                                type="button"
                                                role="option"
                                                aria-selected={selected}
                                                aria-label={`${field.label}: ${opt.label}`}
                                                onClick={() => setValue(opt.value)}
                                                className={`rounded-full px-2.5 py-1 text-xs border transition-colors ${
                                                    selected
                                                        ? "bg-[#d59106]/25 border-[#d59106] text-laranjinha"
                                                        : "bg-gray-800/60 border-gray-600 text-gray-300 hover:border-gray-400"
                                                }`}
                                            >
                                                {opt.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            ) : (
                                <input
                                    type="text"
                                    aria-label={field.label}
                                    value={uiValue}
                                    onChange={(e) => setValue(e.target.value)}
                                    placeholder={field.placeholder}
                                    className="text-black p-1.5 rounded text-xs w-full"
                                />
                            )}

                            {missing ? (
                                <p className="text-[10px] text-amber-400/90">
                                    Selecione um valor para este assert passar.
                                </p>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
